import React from 'react';
import { useHistory } from 'react-router-dom';
import drinkIcon from '../images/drinkIcon.svg';
import exploreIcon from '../images/exploreIcon.svg';
import foodIcon from '../images/mealIcon.svg';

function Footer() {
  const history = useHistory();
  function handleClickDrink() {
    history.push('/drinks');
  }
  function handleClickExplore() {
    history.push('/explore');
  }
  function handleClickFood() {
    history.push('/foods');
  }
  return (
    <footer data-testid="footer" className="footer">
      <button
        type="button"
        onClick={ handleClickDrink }
        className="footer-btn"
      >
        <img
          data-testid="drinks-bottom-btn"
          src={ drinkIcon }
          alt="drink icon"
        />
      </button>
      <button
        type="button"
        onClick={ handleClickExplore }
        className="footer-btn"
      >
        <img
          data-testid="explore-bottom-btn"
          src={ exploreIcon }
          alt="drink icon"
        />
      </button>
      <button
        type="button"
        onClick={ handleClickFood }
        className="footer-btn"
      >
        <img
          data-testid="food-bottom-btn"
          src={ foodIcon }
          alt="drink icon"
        />
      </button>
    </footer>
  );
}

export default Footer;
